import { TextValidator, ValidatorComponentProps } from 'react-material-ui-form-validator';

interface ITextValidatorHcs extends ValidatorComponentProps {
    shrink?: boolean;
}

export const StandardTextValidator = (params: ITextValidatorHcs) => {
    return (
        <TextValidator
            {...params}
            value={params.value == null || params.value == undefined ? "" : params.value}
            InputLabelProps={{ shrink: params.shrink === true ? true : (!(params.value == null || params.value == undefined || params.value === "") || params.type?.includes("date")) }}
        />
    );
}

